import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PropTypes from "prop-types";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
// import Button from "components/CustomButtons/Button.js";
import FileUpload from "components/FileUpload/FileUploadSanction";
import { useDispatch, useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import brandTheme from "brandTheme/Theme";
import { FormControlLabel, Grid, Switch } from "@material-ui/core";
import Button from "components/CustomButtons/Button.js";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import axios from "axios";
import { saveAadharTransaction } from "store/reducers/LoanApplication/LoanApplicationSlice";
import ConfirmationModal from "views/components/ConfirmationModal";
import ToastModal from "views/components/ToastModal";
import OtpModal from "../OtpModal/OtpModal";
import { removeSpecialCharFileName } from "utils/Utils";
import { headerLabel } from "assets/properties/properties";
import { parseAndSetFlag } from "utils/Utils";

const SanctionLetterNew = ({
  setNext,
  setBack,
  loanApplicationId,
  classes,
  setIsEsign,
  isEsign,
  esingDisable,
  setEsignDisable,
  initiatorType,
  featureFlags,
}) => {
  const params = useParams();
  const dispatch = useDispatch();
  let fileUploadComponent = useRef();
  const [record, setRecord] = useState({});
  const [preview, setPreView] = useState("");
  const [previewsigned, setPreviewsigned] = useState("");
  const [imagefile, setImagefile] = useState("");
  const [screenshotCheque, setScreenshotCheque] = useState(null);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const { authToken } = useSelector((state) => state.login.authData);
  const [backFlex, setBackFlex] = useState(false);
  const [senctionPreview, setSanctionPreview] = useState("");
  const [callInProgress, setCallInProgress] = useState(false);
  const [disableGenerate, setDisableGenerate] = useState(false);
  const [htmlData, setHtmlData] = useState("");
  const [estamp, setEstamp] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const hideRepaymentSchedule= parseAndSetFlag(featureFlags?.hideRepaymentSchedule);
  const [confirmationModalHeader, setConfirmationModalHeader] = useState("");
  const [confirmationModalMsg, setConfirmationModalMsg] = useState("");
  const [confirmationModal1, setConfirmationModal1] = useState(false);
  const [confirmationModalHeader1, setConfirmationModalHeader1] = useState("");
  const [confirmationModalMsg1, setConfirmationModalMsg1] = useState("");
  const [confirmationModal2, setConfirmationModal2] = useState(false);
  const [confirmationModalHeader2, setConfirmationModalHeader2] = useState("");
  const [confirmationModalMsg2, setConfirmationModalMsg2] = useState("");
  const [isEStamp, setIsEstamp] = useState(false);
  const hideSanctionLetterPartB = parseAndSetFlag(featureFlags?.hideSanctionLetterPartBFlag);
  const estampFlag = parseAndSetFlag(featureFlags?.eStampFlag);
  const [showModal, setShowModal] = useState(false);
  const [transactionId, setTransactionId] = useState('');
  const [generateLetter, setGenerateLetter]=useState(false)
  const sanctionletterLoaderMessage= featureFlags?.sanctionLetterLoaderMessage
  const [optionUpload, setOptionOnlyUpload]= useState(false);
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  const generateRepaymentSchedule = async () => {
      setCallInProgress(true);
      const res = await apiHandler({
        url:
          endpoint.CREATE_REPAYMENT_SCHEDULE +
          loanApplicationId,
        method: "POST",
        authToken,
      });
      setCallInProgress(false);
      if (res?.data?.error_code) {
        toastUpdate("Error", res?.data?.user_description, true);
      } else {
        console.log("Repayment Schedule Generated")
      }
    };
  
    useEffect(() => {
      if(!hideRepaymentSchedule){
        generateRepaymentSchedule();
      }
    }, [hideRepaymentSchedule]);
  useEffect(() => {
    GetSanctionLetterDetails();
  }, []);

  useEffect(()=>{
    if(screenshotCheque !== null){
      const localUrl = URL.createObjectURL(screenshotCheque);
      setSanctionPreview(localUrl); 
    }
  },[screenshotCheque])

  const getEsignLetter=async()=>{
    setCallInProgress(true)
    //SANCTIONLETTER_UPDATE
    const res = await apiHandler({
      url: endpoint.ESIGN_SANCTION_LETTER + loanApplicationId + "/part-a",
      method: "GET",
      authToken: authToken,
    });
    setCallInProgress(false)
    if(res?.data?.error_code){
      toastUpdate("Error", res?.data?.user_description, true);
    }
    else {
      if(res?.data?.status === "DONE" && res?.data?.fileLink || res?.data?.status === "PENDING"){
        setEsignDisable(true)
        if(res?.data?.fileLink?.includes("esigned") || res?.data?.status === "PENDING"){
          setIsEsign(true)
        }
      }
    }
  }

 useEffect(()=>{
    if (preview && isEsign) {
      getEsignLetter();
    }
  },[preview])

  const GetSanctionLetterDetails = async () => {
    const loanAccountNumber =  loanApplicationId
    setCallInProgress(true)
    const res = await apiHandler({
      url: endpoint.FIND_DOUMENTS + loanAccountNumber,
      method: "GET",
      authToken: authToken,
    });
    setCallInProgress(false)
    if (res?.data?.esignSanctionLetter && res?.data?.estampSanctionLetter) {
      sanctionLetterPreview(res?.data?.esignSanctionLetter);
      setPreView(res?.data?.esignSanctionLetter);
      setIsEstamp(true);
      setEstamp(true);
      setEsignDisable(true)
      setIsEsign(true)
    }else if (res?.data?.estampSanctionLetter){
      setIsEstamp(true);
      setEstamp(true);
      sanctionLetterPreview(res?.data?.estampSanctionLetter);
      setPreView(res?.data?.estampSanctionLetter);
    }else if(res?.data?.sanctionLetterLink && res?.data?.sanctionLetterLink?.includes("esigned")) {
        setEsignDisable(true)
        setIsEsign(true)
        sanctionLetterPreview(res?.data?.sanctionLetterLink);
        setPreView(res?.data?.sanctionLetterLink);
     }else if(res?.data?.sanctionLetterLink) {
        // setEsignDisable(true)
        setOptionOnlyUpload(true);
        sanctionLetterPreview(res?.data?.sanctionLetterLink);
        setPreView(res?.data?.sanctionLetterLink);
     }else if(res?.data?.preSanctionLetterLink){
      sanctionLetterPreview(res?.data?.preSanctionLetterLink);
      setPreView(res?.data?.preSanctionLetterLink);
     }
  };

  const sanctionLetterPreview = async (link) => {
    setSanctionPreview(link);
  };
  const GenerateSanctionLetter = async () => {
    setCallInProgress(true)
    setGenerateLetter(true)
    //SANCTION_LETTER
    const res = await apiHandler({
      url: endpoint.GENERATE_SANCTION_LETTER_UPDATED + loanApplicationId + "/part-a",
      method: "GET",
      authToken: authToken,
    });
    setCallInProgress(false)
    setGenerateLetter(false)
    if(res?.data?.error_code){
      toastUpdate("Error", res?.data?.user_description, true);
    }else{
      if (res?.data?.fileLink) {
        setPreView(res?.data?.fileLink);
        sanctionLetterPreview(res?.data?.fileLink);
        setOptionOnlyUpload(false);
      }
    }
  };
 const handleProceedUpload=()=>{
        setConfirmationModalHeader1("Preview");
    setConfirmationModalMsg1("Preview uploaded sanction letter");
    setConfirmationModal1(true);
  }
  const handleNegativeUploadResponse = () => {
    setConfirmationModal1(false);
    setConfirmationModalHeader1("");
    setConfirmationModalMsg1("");
  };
  const handlePositiveUploadResponse = async () => {
    handleNegativeUploadResponse();
    // Call API to delete loanMarking
    handleUpload();
  };

  const handleProceedGenerate = () => {
    setConfirmationModalHeader2("Re-generate");
    setConfirmationModalMsg2("Do you want to re-generate sanction letter");
    setConfirmationModal2(true);
  }

  const handleNegativeGenerateResponse = () => {
    setConfirmationModal2(false);
    setConfirmationModalHeader2("");
    setConfirmationModalMsg2("");
  };
  const handlePositiveGenerateResponse = async () => {
    handleNegativeGenerateResponse();
    // Call API to delete loanMarking
    GenerateSanctionLetter();
  };

  const handleUpload = async (event) => {
    if (imagefile) {
      Updatesanctionletter(imagefile);
    } else {
      if (screenshotCheque || htmlData) {
        setCallInProgress(true);
        const formData = new FormData();
        const fileName = removeSpecialCharFileName(screenshotCheque.name);
        formData.append("file", screenshotCheque, fileName);
        const path = await apiHandler({
          url: endpoint.FILE_UPLOAD,
          method: "POST",
          authToken: authToken,
          data: formData,
        });
        setCallInProgress(false);
        const uploadedPath = path.data;
        Updatesanctionletter(uploadedPath.name);
      } else {
        toastUpdate("Error","Upload Signed Sanction letter Before Submited", true);
      }
    }
    // setNext(); // kamal
  };
  const Updatesanctionletter = async (filename) => {
    setCallInProgress(true)
    //SANCTIONLETTER_UPDATE
    const res = await apiHandler({
      url: endpoint.ADMIN_DOCUMENT_UPDATELINKS,
      method: "POST",
      authToken: authToken,
      data: {
        loanApplicationId: loanApplicationId,
        sanctionLetterLink: filename,
      },
    });
    setCallInProgress(false)
    //this.setState({ callInProgress: false });
    if (res?.data?.error_code && res?.data?.error_code === 403) {
      toastUpdate("Error", res?.data?.user_description, true);
      return;
    } else if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
      return;
    } else {
      toastUpdate("Success", "Update sanction Letter successfully", true);

      setBackFlex(true);
      setNext();
    }

    //  props.navigate(`/admin/document/` + params.loanApplicationId);
  };

  const handleEsign=async()=>{
    setCallInProgress(true)
    //SANCTIONLETTER_UPDATE
    const res = await apiHandler({
      url: endpoint.ESIGN_SANCTION_LETTER + loanApplicationId + "/part-a",
      method: "POST",
      authToken: authToken,
    });
    setCallInProgress(false)
    if(res?.data?.error_code){
      toastUpdate("Error", res?.data?.user_description, true);
    }
    else {
      if(res?.data?.status === "OTP_VALIDATION"){
        setTransactionId(res?.data?.transactionId)
        setShowModal(true);
      }else{
        openHtmlInNewTab(res?.data);
        setNext();
      }
    }
  }
  const openHtmlInNewTab = (htmlResponse) => {
    const blob = new Blob([htmlResponse], { type: "text/html" });
    const url = URL.createObjectURL(blob);
    setHtmlData(url)
    window.open(url);

  };
  const handleSwitchChange = async () =>{
    setIsEsign(!isEsign);
  }

  const handleEstampSwitch = async () => {
    setIsEstamp(!isEStamp);
  };

  const handleEsignNext = () =>{
    if(!esingDisable && !optionUpload){
      toastUpdate("Error","Please Esign the Document", true);
    } else{
      setNext()
    }

  }
  const handleCancelUser = () => {
    setBack();
    //props.history.go(-1);
  };

  const handleNegativeResponse = () => {
    setConfirmationModal(false);
    setConfirmationModalHeader("");
    setConfirmationModalMsg("");
  };
  const handlePositiveResponse = async () => {
    handleNegativeResponse();
    // Call API to delete loanMarking
    handleEstamp();
  };
  const handleEstamp = async () => {
    setCallInProgress(true);
    //SANCTION_LETTER
    const res = await apiHandler({
      url: endpoint.ESTAMP_SANCTION_LETTER + loanApplicationId,
      method: "POST",
      authToken: authToken,
    });
    setCallInProgress(false);
    if(res?.data?.error_code){
      toastUpdate("Error","Some issue with eStamp. Please check with admin.", true);
    }else if (res?.data?.postEstampDocLink) {
      sanctionLetterPreview(res?.data?.postEstampDocLink);
      setEstamp(true);
    }
  };

  const proceedEstamp = () => {
    setConfirmationModalHeader("EStamp");
    setConfirmationModalMsg("Do you want to Estamp on sanction letter");
    setConfirmationModal(true);
  };
 const renderButton = () => {
  return (
    <Grid container xs={12} sm={12} md={6} lg={6} spacing={2} justifyContent="flex-end" alignItems="center">
      {/* RE-Generate Button */}
      <Grid item>
        <Button
          onClick={handleProceedGenerate}
          className={classes.nextButton}
          disabled={disableGenerate}
        >
          RE-Generate
        </Button>
      </Grid>

      <Grid item>
        {isEsign ? (
          <Button
            size="small"
            className={classes.nextButton}
            onClick={handleEsign}
          >
            Esign
          </Button>
        ) : (
          <FileUpload
            supportedMimeType={["application/pdf"]}
            addButtonProps={{
              color: brandTheme.buttonColor,
              round: false,
            }}
            changeButtonProps={{
              color: brandTheme.buttonColor,
              round: false,
            }}
            removeButtonProps={{
              color: "danger",
              round: false,
            }}
            sendFile={(file) => {
              setScreenshotCheque(file);
              setImagefile("");
            }}
            disabledButton={htmlData}
            ref={fileUploadComponent}
            classes={classes}
            buttonTitle={optionUpload ? "Change" : "Upload"}
            lettername="sanction_Letter"
            optionUpload={optionUpload}
          />
        )}
      </Grid>
    </Grid>
  );
};

const title = hideSanctionLetterPartB ? headerLabel?.sanctionLetter: headerLabel?.sanctionLetterPartA
const handleClose = () => {
  setShowModal(!showModal);
};
  const sendEMailOtp = async () => {
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.RESEND_OTP_ESIGN + transactionId,
      method: "PUT",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
    }else{
      toastUpdate("Success", "Otp sent successfully", true);
    }
  };
const Otp = async (code1) => {
  setCallInProgress(true);
  const response = await apiHandler({
    url: endpoint.OTP_VALIDATE_ESIGN,
    method: "POST",
    authToken: authToken,
    data: {
      txnId: transactionId,
      otp: code1,
    },
  });
  setCallInProgress(false);
    if (response?.data?.error_code) {
      toastUpdate("Error",'Kindly verify the otp or resend the otp', true);
    } else {
      setNext();
      setShowModal(false);
    }
  };
  return (
    // <div>
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
          <SubHeader
                            label={title}
                            subLabel={`${headerLabel.loanAppId} ${loanApplicationId}`}
                            onlyLabel/>
      </Grid>
      <GridContainer style={{ marginTop: 40 }}>
        <GridItem xs={12} sm={12} md={12} lg={12}>
          <GridContainer>
            {!preview ? (
              <>
                <GridItem
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  style={{ textAlign: "center" }}
                >
                  {((!estamp && estampFlag) || !estampFlag)&& (
                    <Button
                      onClick={() => GenerateSanctionLetter()}
                      className={classes.nextButton}
                      disabled={disableGenerate}
                    >
                      Generate
                    </Button>
                  )}
                </GridItem>
              </>
            ) : (
              <>
                {(estampFlag && initiatorType !== 'CUSTOMER') && (
                  <GridItem
                    xs={12}
                    sm={12}
                    md={6}
                    lg={6}
                    style={{ textAlign: "start" }}
                  >
                    <label
                      style={{
                        text: "bold",
                        marginRight: "10px",
                        color: "black",
                      }}
                    >
                      Do you want to Estamp
                    </label>
                    <label style={{ marginRight: "15px", color: "black" }}>
                      No
                    </label>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={isEStamp}
                          onChange={handleEstampSwitch}
                          name="checkedB"
                          color="primary"
                          disabled={estamp}
                        />
                      }
                    />
                    <label style={{ color: "black" }}>Yes</label>
                  </GridItem>
                )}
                {initiatorType !== 'CUSTOMER' &&
                <GridItem
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  style={{ textAlign: "start" }}
                >
                  <label
                    style={{
                      text: "bold",
                      marginRight: "10px",
                      color: "black",
                    }}
                  >
                    Do you want to esign through Mobile Number{" "}
                  </label>
                  <label style={{ marginRight: "15px", color: "black" }}>
                    No
                  </label>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={isEsign}
                        onChange={handleSwitchChange}
                        name="checkedB"
                        color="primary"
                        disabled={esingDisable || optionUpload || (estampFlag && !estamp)}
                      />
                    }
                  />
                  <label style={{ color: "black" }}>Yes</label>
                </GridItem>
                }
                  {initiatorType !== 'CUSTOMER' &&
                  <>
                {estampFlag ? 
                <>
                {(!esingDisable && estampFlag) && (
                  <>
                    {isEStamp && !estamp ? (
                      <GridItem
                        xs={12}
                        sm={12}
                        md={6}
                        lg={6}
                        style={{ textAlign: "end" }}
                      >
                        <Button
                          size="small"
                          className={classes.nextButton}
                          onClick={proceedEstamp}
                        >
                          E-stamp
                        </Button>
                      </GridItem>
                    ) : (
                      renderButton()
                    )}
                  </>
                )} 
                </>
                :
                <>
                {!esingDisable ? renderButton() : ""}
                </>
              }
              </>
            }
                <GridItem xs={12} sm={12} md={12} lg={12}>
                  {(preview !== "" || (estampFlag && senctionPreview)) ? (
                  <iframe src={senctionPreview? senctionPreview: preview} width="100%" height="500px" />
                  ) : (
                    <div>Downloading Sanction Document</div>
                  )}
                </GridItem>
              </>
            )}
          </GridContainer>
          <GridContainer>
            <GridItem
              xs={12}
              sm={12}
              md={12}
              lg={12}
              style={{textAlign: window.innerWidth < 360 ? "center" : "right", }}
            >
              <Button
                size="small"
                className={classes.nextButton1}
                onClick={() => handleCancelUser()}
              >
                Back
              </Button>
              {preview &&
                <Button
                  // style={{ margin: "5px" }}
                  size="small"
                  // color="info"
                  className={classes.nextButton}
                  disabled={callInProgress || initiatorType === 'CUSTOMER'}
                  onClick={(event) => (esingDisable || (optionUpload && !screenshotCheque)) ? handleEsignNext() : handleProceedUpload()}
                >
                  Next
                </Button>
              }
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>
      {callInProgress && <CircularProgresss callInProgress={callInProgress} text={generateLetter ?  sanctionletterLoaderMessage : "Processing..."} />}
      {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
      {confirmationModal && (
        <ConfirmationModal
          confirmationModal={confirmationModal}
          confirmationModalHeader={confirmationModalHeader}
          confirmationModalMsg={confirmationModalMsg}
          handleNegativeButton={handleNegativeResponse}
          handlePositiveButton={handlePositiveResponse}
        />
      )}
      {confirmationModal1 && (
        <ConfirmationModal
          confirmationModal={confirmationModal1}
          confirmationModalHeader={confirmationModalHeader1}
          confirmationModalMsg={confirmationModalMsg1}
          handleNegativeButton={handleNegativeUploadResponse}
          handlePositiveButton={handlePositiveUploadResponse}
        />
      )}
      {confirmationModal2 && (
        <ConfirmationModal
          confirmationModal={confirmationModal2}
          confirmationModalHeader={confirmationModalHeader2}
          confirmationModalMsg={confirmationModalMsg2}
          handleNegativeButton={handleNegativeGenerateResponse}
          handlePositiveButton={handlePositiveGenerateResponse}
        />
      )}
      {showModal && (
        <OtpModal
          handleClose={handleClose}
          showModal={showModal}
          Otp={Otp}
          ResendOtp={sendEMailOtp}
        />
      )}
    </Grid>
  );
};

SanctionLetterNew.propTypes = {
  classes: PropTypes.object,
  setNext: PropTypes.func,
  setBack: PropTypes.func,
  loanApplicationId: PropTypes.object,
};

export default SanctionLetterNew;